import { render, staticRenderFns } from "./MobilePriceTable.vue?vue&type=template&id=1adeda56&scoped=true&"
import script from "./MobilePriceTable.vue?vue&type=script&lang=js&"
export * from "./MobilePriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adeda56",
  null
  
)

export default component.exports